import React from 'react';
import { Link } from 'react-router-dom';
import Sale01 from '../components/sale/Sale01';
import mentorAvatar from '../assets/images/notowidjojo.png';

const highlights = [
  { icon: '📈', value: '12+', label: 'Tahun Pengalaman Trading' },
  { icon: '🎓', value: '5.000+', label: 'Murid Termentoring' },
  { icon: '🏆', value: 'Top 10', label: 'Trader Indonesia' },
];

const expertise = [
  'Analisis Teknikal & Fundamental',
  'Manajemen Risiko Portofolio',
  'Strategi Trading Saham & Crypto',
  'Psikologi Trading Profesional',
];

const allMentors = [
  { name: 'Ki Noto Widjojo', role: 'Head Mentor & Praktisi Trading', exp: '12+ th', sessions: 5000, initial: 'NW', desc: 'Praktisi trading dengan pengalaman lebih dari 12 tahun di pasar saham dan crypto. Membimbing ribuan trader dari pemula hingga mahir.', isFeatured: true },
  { name: 'Dimas Prasetyo', role: 'Senior Trader', exp: '12 th', sessions: 24, initial: 'DP', desc: 'Senior trader spesialis analisis teknikal dan strategi entry/exit point.' },
  { name: 'Rina Wijaya', role: 'Analis Teknikal', exp: '8 th', sessions: 18, initial: 'RW', desc: 'Analis teknikal dengan keahlian dalam chart pattern dan indikator teknikal.' },
  { name: 'Pak Sum', role: 'Mentor Portfolio', exp: '10 th', sessions: 128, initial: 'PS', desc: 'Mentor portfolio yang ahli dalam diversifikasi dan manajemen risiko investasi.' },
  { name: 'Budi Santoso', role: 'Trader Crypto', exp: '6 th', sessions: 42, initial: 'BS', desc: 'Trader crypto dengan fokus pada analisis on-chain dan market sentiment.' },
  { name: 'Sari Dewi', role: 'Trader Forex & Saham', exp: '9 th', sessions: 56, initial: 'SD', desc: 'Trader multi-pasar dengan pengalaman di forex, saham, dan komoditas.' },
  { name: 'Agus Hermawan', role: 'Risk Management Specialist', exp: '11 th', sessions: 37, initial: 'AH', desc: 'Spesialis manajemen risiko yang membantu trader membangun sistem proteksi modal.' },
  { name: 'Fitriani', role: 'Swing Trader', exp: '7 th', sessions: 31, initial: 'FT', desc: 'Swing trader dengan track record konsisten dalam jangka menengah.' },
];

function MentorPage() {
  const featured = allMentors.find(m => m.isFeatured);
  const others = allMentors.filter(m => !m.isFeatured);

  return (
    <div>
      <section style={{
        padding: '100px 0 80px',
        background: 'linear-gradient(135deg, #0a1628 0%, #0f1a3a 30%, #1a0f2e 100%)',
        position: 'relative',
        overflow: 'hidden',
      }}>
        <div style={{
          position: 'absolute', top: '-15%', left: '-8%', width: 480, height: 480,
          borderRadius: '50%', background: 'radial-gradient(circle, rgba(12,143,134,0.14) 0%, transparent 70%)',
          pointerEvents: 'none',
        }} />
        <div style={{
          position: 'absolute', bottom: '-25%', right: '-5%', width: 520, height: 520,
          borderRadius: '50%', background: 'radial-gradient(circle, rgba(139,92,246,0.1) 0%, transparent 70%)',
          pointerEvents: 'none',
        }} />
        <div className="container" style={{ position: 'relative', zIndex: 1 }}>
          <div className="row">
            <div className="col-md-12">
              <div className="block-text center">
                <div style={{
                  display: 'inline-flex', alignItems: 'center', gap: 8,
                  background: 'rgba(12,143,134,0.15)', borderRadius: 20,
                  padding: '6px 16px', marginBottom: 16,
                }}>
                  <span style={{ color: 'var(--primary)', fontSize: 10 }}>✦</span>
                  <span style={{ color: 'var(--primary)', fontSize: 13, fontWeight: 600 }}>Mentor Profesional Tradiora</span>
                </div>
                <h3 className="heading" style={{ color: '#fff' }}>Kenali Mentor Anda</h3>
                <p className="fs-20" style={{ color: 'rgba(255,255,255,0.7)', maxWidth: 600, margin: '0 auto' }}>
                  Belajar langsung dari 50+ mentor profesional yang berpengalaman di pasar saham & crypto
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section style={{ padding: '80px 0' }}>
        <div className="container">
          <div className="row align-items-center" data-aos="fade-up" data-aos-duration="1000">
            <div className="col-xl-5 col-lg-5 col-md-12">
              <div style={{
                position: 'relative',
                borderRadius: 24,
                padding: 4,
                background: 'linear-gradient(135deg, var(--primary), #8b5cf6)',
                maxWidth: 380,
                margin: '0 auto',
                boxShadow: '0 20px 60px rgba(12,143,134,0.25)',
              }}>
                <div style={{ borderRadius: 20, overflow: 'hidden', background: '#0b1120' }}>
                  <img
                    src={mentorAvatar}
                    alt={featured.name}
                    style={{ width: '100%', display: 'block' }}
                  />
                </div>
                <div style={{
                  position: 'absolute', bottom: -18, left: '50%', transform: 'translateX(-50%)',
                  background: '#fff', borderRadius: 30, padding: '8px 22px',
                  display: 'flex', alignItems: 'center', gap: 8, whiteSpace: 'nowrap',
                  boxShadow: '0 8px 24px rgba(0,0,0,0.2)',
                }}>
                  <span style={{ color: '#000', fontWeight: 700, fontSize: 14 }}>{featured.name}</span>
                </div>
              </div>
            </div>
            <div className="col-xl-7 col-lg-7 col-md-12">
              <div style={{ paddingTop: 12 }}>
                <h3 style={{ color: 'var(--onsurface)', fontSize: 26, fontWeight: 700, marginBottom: 14 }}>
                  {featured.role}
                </h3>
                <p style={{ color: 'var(--text)', fontSize: 16, lineHeight: 1.8, marginBottom: 24 }}>
                  {featured.desc}
                </p>
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: 12, marginBottom: 28 }}>
                  {expertise.map((item, i) => (
                    <div key={i} style={{
                      display: 'flex', alignItems: 'center', gap: 10,
                      background: 'var(--surface)', borderRadius: 12,
                      padding: '12px 14px', border: '1px solid var(--line)',
                    }}>
                      <span style={{
                        width: 22, height: 22, flexShrink: 0, borderRadius: '50%',
                        background: 'var(--primary)', color: '#fff', fontSize: 12,
                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                      }}>✓</span>
                      <span style={{ color: 'var(--onsurface)', fontSize: 14 }}>{item}</span>
                    </div>
                  ))}
                </div>
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 12, marginBottom: 28 }}>
                  {highlights.map((h, i) => (
                    <div key={i} style={{
                      background: 'var(--surface)', borderRadius: 14,
                      padding: '16px 10px', textAlign: 'center',
                      border: '1px solid var(--line)',
                    }}>
                      <div style={{ fontSize: 20, marginBottom: 6 }}>{h.icon}</div>
                      <div style={{ color: 'var(--primary)', fontSize: 20, fontWeight: 800 }}>{h.value}</div>
                      <div style={{ color: 'var(--text)', fontSize: 11, marginTop: 2 }}>{h.label}</div>
                    </div>
                  ))}
                </div>
                <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap' }}>
                  <a
                    href="#"
                    style={{
                      display: 'inline-flex', alignItems: 'center', gap: 8,
                      background: 'linear-gradient(135deg, var(--primary), #8b5cf6)',
                      color: '#fff', fontWeight: 600, fontSize: 14,
                      borderRadius: 12, padding: '12px 24px', textDecoration: 'none',
                    }}
                    onMouseEnter={e => { e.currentTarget.style.opacity = '0.9'; }}
                    onMouseLeave={e => { e.currentTarget.style.opacity = '1'; }}
                  >
                    📩 Mulai Mentoring
                  </a>
                  <a
                    href="#"
                    style={{
                      display: 'inline-flex', alignItems: 'center', gap: 8,
                      background: 'var(--surface)', color: 'var(--onsurface)',
                      fontWeight: 600, fontSize: 14, borderRadius: 12,
                      padding: '12px 24px', textDecoration: 'none',
                      border: '1px solid var(--line)',
                    }}
                    onMouseEnter={e => { e.currentTarget.style.background = 'rgba(255,255,255,0.08)'; }}
                    onMouseLeave={e => { e.currentTarget.style.background = 'var(--surface)'; }}
                  >
                    ▶ Lihat Profil
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section style={{ padding: '0 0 80px' }} data-aos="fade-up" data-aos-duration="1000">
        <div className="container">
          <div style={{ textAlign: 'center', marginBottom: 40 }}>
            <h3 style={{ color: 'var(--onsurface)', fontSize: 24, fontWeight: 700, marginBottom: 8 }}>
              Semua Mentor di Tradiora
            </h3>
            <p style={{ color: 'var(--text)', fontSize: 15 }}>
              Lebih dari 50 mentor profesional siap membimbing perjalanan trading Anda
            </p>
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))', gap: 20 }}>
            {others.map((m, i) => (
              <div key={i} style={{
                background: 'var(--surface)', borderRadius: 16,
                padding: '24px 20px', textAlign: 'center',
                border: '1px solid var(--line)',
                transition: 'all 0.3s ease',
                cursor: 'pointer',
              }}
                onMouseEnter={e => { e.currentTarget.style.borderColor = 'var(--primary)'; e.currentTarget.style.transform = 'translateY(-4px)'; e.currentTarget.style.boxShadow = '0 12px 40px rgba(12,143,134,0.15)'; }}
                onMouseLeave={e => { e.currentTarget.style.borderColor = 'var(--line)'; e.currentTarget.style.transform = ''; e.currentTarget.style.boxShadow = ''; }}
              >
                <div style={{
                  width: 64, height: 64, borderRadius: '50%',
                  background: 'linear-gradient(135deg, var(--primary), #8b5cf6)',
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  color: '#fff', fontSize: 24, fontWeight: 700,
                  margin: '0 auto 14px',
                }}>
                  {m.initial}
                </div>
                <div style={{ color: 'var(--onsurface)', fontSize: 16, fontWeight: 700, marginBottom: 4 }}>{m.name}</div>
                <div style={{ color: 'var(--primary)', fontSize: 13, fontWeight: 600, marginBottom: 8 }}>{m.role}</div>
                <div style={{ color: 'var(--text)', fontSize: 13, lineHeight: 1.6, marginBottom: 12 }}>
                  {m.desc}
                </div>
                <div style={{ color: 'var(--text)', fontSize: 13 }}>{m.exp} pengalaman</div>
              </div>
            ))}
          </div>
          <div style={{ textAlign: 'center', marginTop: 28 }}>
            <a
              href="#"
              style={{
                display: 'inline-flex', alignItems: 'center', gap: 8,
                color: 'var(--primary)', fontWeight: 600, fontSize: 14,
                textDecoration: 'none', padding: '10px 24px',
                borderRadius: 10, border: '1px solid rgba(12,143,134,0.3)',
              }}
            >
              Lihat Semua Mentor →
            </a>
          </div>
        </div>
      </section>

      <section style={{ padding: '0 0 80px' }}>
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div style={{
                background: 'linear-gradient(135deg, #0a1628 0%, #1a0a2e 30%, #8b5cf6 100%)',
                borderRadius: 24,
                padding: '56px',
                textAlign: 'center',
                position: 'relative',
                overflow: 'hidden',
              }}>
                <div style={{
                  position: 'absolute', top: '-20%', right: '-5%', width: 300, height: 300,
                  borderRadius: '50%', background: 'rgba(255,255,255,0.05)', filter: 'blur(40px)',
                }} />
                <div style={{ position: 'relative', zIndex: 1 }}>
                  <h3 style={{ color: '#fff', fontSize: 28, marginBottom: 16 }}>
                    Ingin Menjadi Mentor?
                  </h3>
                  <p style={{ color: 'rgba(255,255,255,0.8)', fontSize: 17, maxWidth: 550, margin: '0 auto 32px', lineHeight: 1.7 }}>
                    Bagikan ilmu dan pengalaman trading Anda kepada ribuan trader di seluruh Indonesia. 
                    Jadilah bagian dari komunitas mentor profesional Tradiora dan bangun karir sebagai mentor trading.
                  </p>
                  <div style={{ display: 'flex', gap: 16, justifyContent: 'center', flexWrap: 'wrap' }}>
                    <Link to="/contact" className="btn-action">Daftar Menjadi Mentor</Link>
                    <Link to="/syarat-ketentuan-mentor" className="btn-action style-2">Syarat Ketentuan Mentor</Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Sale01 />
    </div>
  );
}

export default MentorPage;
